import { render, staticRenderFns } from "./AdminGetView.vue?vue&type=template&id=e6b94a84"
import script from "./AdminGetView.vue?vue&type=script&lang=js"
export * from "./AdminGetView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports